import { Sun, Moon, Monitor } from 'lucide-react';
import { Button } from '@fyos/components';
import { useThemeStore } from '@/stores/themeStore';

const CYCLE: Array<'light' | 'dark' | 'system'> = ['light', 'dark', 'system'];

export default function ThemeToggle() {
  const { theme, setTheme } = useThemeStore();

  const next = () => {
    const idx = CYCLE.indexOf(theme);
    setTheme(CYCLE[(idx + 1) % CYCLE.length]);
  };

  const icon =
    theme === 'dark' ? <Moon className="h-4 w-4" /> :
    theme === 'system' ? <Monitor className="h-4 w-4" /> :
    <Sun className="h-4 w-4" />;

  return (
    <Button variant="ghost" size="sm" onClick={next} aria-label={`Theme: ${theme}`}>
      {icon}
    </Button>
  );
}
